import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Avatar,
  Badge,
  Tooltip,
  Box,
} from "@mui/material";
import { Menu as MenuIcon, Notifications } from "@mui/icons-material";

const Header = ({
  onMenuClick,
  onProfileOpen,
  onNotificationOpen,
  notifications = [],
  user,
  isMobile,
}) => {
  return (
    <AppBar
      position="fixed"
      sx={{
        width: { md: `calc(100% - 260px)` },
        ml: { md: `260px` },
        background: "var(--primary-gradient)",
        backdropFilter: "saturate(140%) blur(6px)",
      }}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onMenuClick}
          sx={{ mr: 2, display: { md: "none" } }}
        >
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
          Hostly Inn Management System
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Tooltip title="Notifications">
            <IconButton color="inherit" onClick={onNotificationOpen}>
              <Badge badgeContent={notifications.filter((n) => !n.read).length} color="error">
                <Notifications />
              </Badge>
            </IconButton>
          </Tooltip>

          <Tooltip title="Profile Menu">
            <IconButton onClick={onProfileOpen} sx={{ p: 0, ml: 2 }}>
              <Avatar
                alt={user?.name}
                src={user?.profilePicture?.url}
                sx={{ width: 32, height: 32, border: "2px solid white" }}
              >
                {user?.name?.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
